"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HttpResponse =
/** @class */
function () {
  function HttpResponse(options) {
    this.statusCode = options.statusCode;
    this.headers = options.headers || {};
    this.body = options.body;
  }

  HttpResponse.isInstance = function (response) {
    //determine if response is a valid HttpResponse
    if (!response) return false;
    var resp = response;
    return typeof resp.statusCode === "number" && typeof resp.headers === "object";
  };

  return HttpResponse;
}();

exports.HttpResponse = HttpResponse;